if (!customElements.get('featured-slider')) {
  class FeaturedSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sliderElement = this.querySelector('[data-slider]');

      if (!this.sliderElement) return;

      this.options = {
        slidesPerView: 1,
        draggable: true,
        watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          enabled: true,
          draggable: true,
        },
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          990: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          1200: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
        },
      };

      if (+this.dataset.maxSlides > 2) {
        this.options.breakpoints['990'].slidesPerView = 3;
        this.options.breakpoints['1200'].slidesPerView = 3;
      }

      if (+this.dataset.maxSlides > 3) {
        this.options.breakpoints['1200'].slidesPerView = 4;
      }

      this.slider = new Swiper(this.sliderElement, this.options);
    }
  }

  customElements.define('featured-slider', FeaturedSlider);
}
